import React, { Fragment } from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { useCreditCardIframe } from 'src/components/CreditCardFormIframe/useCreditCardIframe';
import { CreditCardFormIframe } from 'src/components/CreditCardFormIframe/CreditCardFormIframe';

export interface IEnterpriseCardFormProps {
  corpId: string;
  onSuccess: () => void;
  onError: () => void;
}

export function EnterpriseCardForm({
  corpId,
  onSuccess,
  onError,
}: IEnterpriseCardFormProps): JSX.Element {
  const {
    onIframeSubmit,
    iframeContainerId,
    cardIsValid,
    isSubmitting,
    isLoadingComponent,
  } = useCreditCardIframe({
    corpId,
    onSuccess,
    onError,
    idSuffix: 'enterprise-onboarding-payment',
  });

  return (
    <>
      <CreditCardFormIframe
        id={iframeContainerId}
        isLoadingComponent={isLoadingComponent}
      />
      <Button
        variant="primary"
        buttonSize="medium"
        disabled={!cardIsValid || isSubmitting}
        isLoading={isSubmitting}
        onClick={(evt) => {
          evt.preventDefault();
          onIframeSubmit();
        }}
      >
        Save credit card
      </Button>
    </>
  );
}
